import { BaseModel } from './base.model';
import { BehavioranchorModel } from './behavioranchor.model';
import { Deserializable } from './deserializable';

export class CompetenceModel extends BaseModel implements Deserializable {

  // columns
  name: any;

  // client
  value: number;
  active: boolean;

  // relations
  behavioranchors: Array<BehavioranchorModel> = [];

  deserialize(input: any): this {
    Object.assign(this, input);
    // behavioranchors
    let behavioranchors = null;
    if (this.behavioranchors !== null && this.behavioranchors !== undefined) {
      behavioranchors = [];
      this.behavioranchors.forEach((behavioranchor: BehavioranchorModel) => {
        behavioranchors.push(new BehavioranchorModel().deserialize(behavioranchor, false));
      });
    }
    this.behavioranchors = behavioranchors;
    this.loaded = true;
    return this;
  }

}
